module.exports = __webpack_public_path__ + "img/friends-logo6.f3d090a6.png";